import { Box, styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';
import { AIGradientIcon } from '@setvi/shared/components/sicons';

export const EnhancedButton = styled(SButton)({
  borderRadius: '120px',
  minHeight: 0,
  padding: '4px 12px',
  fontWeight: 600,
  fontSize: '12px'
});

export const EnhancedButtonIcon = styled(AIGradientIcon)({
  fontSize: '16px'
});

export const EnhancedEmptyContentContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%'
});
